import { render, staticRenderFns } from "./RoomFiles.vue?vue&type=template&id=1cec64d7&"
import script from "./RoomFiles.vue?vue&type=script&lang=js&"
export * from "./RoomFiles.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  ,true
)

export default component.exports